import { usePathname } from '@/shared/lib/router'

/**
 * Hook para saber se um href está ativo com suporte a subpaths e match exato.
 * @param href Rota base que deseja verificar
 * @param options.exactMatch Se true, só retorna ativo se o path for igual ao href
 * @returns boolean
 */
type UseActiveNavOptions = {
  exactMatch?: boolean
}

export const useActiveNav = (
  href: string,
  options: UseActiveNavOptions = {}
): boolean => {
  const { exactMatch = false } = options
  const pathname = usePathname()

  if (!pathname) return false

  // Garante que não termina com '/' (a não ser que seja '/')
  const normalize = (p: string) =>
    p.length > 1 && p.endsWith('/') ? p.slice(0, -1) : p

  const normalizedHref = normalize(href)
  const normalizedPath = normalize(pathname)

  if (exactMatch) {
    return normalizedPath === normalizedHref
  }

  // subpath match: "/" sempre ativo, senão path deve começar com href + "/"
  if (normalizedHref === '/') return normalizedPath === '/'

  return (
    normalizedPath === normalizedHref ||
    normalizedPath.startsWith(`${normalizedHref}/`)
  )
}
